import React, { useEffect, useState, useRef, useCallback } from "react";

const LOGO = process.env.REACT_APP_LOGO_URL;
const DISCORD_URL = process.env.REACT_APP_DISCORD_URL;

export { LOGO, DISCORD_URL };

const SPARK_COUNT = 7;
// vw/vh percentages — keep away from hero logo bubble (desktop only-ish)
const LOGO_NO_GO = { x1: 60, x2: 96, y1: 18, y2: 58 };

function inLogoZone(x, y) {
  return x >= LOGO_NO_GO.x1 && x <= LOGO_NO_GO.x2 && y >= LOGO_NO_GO.y1 && y <= LOGO_NO_GO.y2;
}

function randomSpark(id) {
  let x, y;
  for (let i = 0; i < 12; i++) {
    x = Math.random() * 92 + 3;
    y = Math.random() * 90 + 3;
    if (!inLogoZone(x, y)) break;
  }
  // Random direction: bias slightly downward but allow many angles (-120° .. +60°)
  // Then rotate baseline by ~25° so default looks natural too
  const angle = -120 + Math.random() * 180; // -120 .. +60 degrees
  const distance = 520 + Math.random() * 460; // 520..980 px

  return {
    id,
    key: `${id}-${Math.random().toString(36).slice(2)}`,
    top: `${y}%`,
    left: `${x}%`,
    duration: 22 + Math.random() * 16, // 22..38s — much less frequent
    delay: Math.random() * 14, // 0..14s stagger
    variant: Math.random() < 0.35 ? "gold" : "white",
    angle,
    distance,
  };
}

export const StarsBackground = () => {
  const [sparks, setSparks] = useState(() =>
    Array.from({ length: SPARK_COUNT }, (_, i) => randomSpark(i))
  );
  const sparksRef = useRef(sparks);
  sparksRef.current = sparks;

  const respawn = useCallback((id) => {
    setSparks((prev) => prev.map((s) => (s.id === id ? randomSpark(id) : s)));
  }, []);

  // light safety fallback in case animationiteration is missed
  useEffect(() => {
    const interval = setInterval(() => {
      const pick = Math.floor(Math.random() * SPARK_COUNT);
      respawn(pick);
    }, 15000);
    return () => clearInterval(interval);
  }, [respawn]);

  return (
    <div className="stars-bg" aria-hidden="true" data-testid="stars-bg">
      {sparks.map((s) => (
        <span
          key={s.key}
          className={`spark ${s.variant === "gold" ? "spark-gold" : "spark-white"}`}
          style={{
            top: s.top,
            left: s.left,
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
            // CSS variables consumed inside @keyframes via transform
            "--angle": `${s.angle}deg`,
            "--dist": `${s.distance}px`,
          }}
          onAnimationIteration={() => respawn(s.id)}
        />
      ))}
    </div>
  );
};
